// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserReviewsForm-commonHeaderAdmin-UsNnT {
	position: fixed !important;
}

.UserReviewsForm-adminLayout-mvAB4 {
	padding-top: 64px !important;
}

.UserReviewsForm-box-Iw0Q0 h2 {
	font-size: 21px;
	font-weight: 600;
}

.UserReviewsForm-exportLink-x45UE {
	margin-bottom: -29px;
}

.UserReviewsForm-blockCenter-JPbC6 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.UserReviewsForm-panelHeader-HsCu2 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.UserReviewsForm-currencyselect-Sqy6j {
	width: 100%;
	margin-right: 0px;
}

.UserReviewsForm-panelHeader-HsCu2 {
	overflow: hidden;
	position: relative;
}

.UserReviewsForm-mar0-b8aea {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.UserReviewsForm-blockCenter-JPbC6 {
		padding: 0px;
	}

	.UserReviewsForm-panelHeader-HsCu2 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.UserReviewsForm-sideAdminPageWrapper-uvwnq {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.UserReviewsForm-panelHeader-HsCu2 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.UserReviewsForm-table-d3XZK {
	display: table;
}

.UserReviewsForm-tableRow-FqJqX {
	display: table-row;
}

.UserReviewsForm-tableCell-wcxzn {
	display: table-cell;
	float: none;
}

.UserReviewsForm-formGroup-cjcjP {
	margin-bottom: 6px;
}

.UserReviewsForm-select-_JLbs {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.UserReviewsForm-noMargin-HM8fD {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.UserReviewsForm-exportLink-x45UE {
	padding-top: 10px;
	padding-right: 10px;
}

.UserReviewsForm-labelTextNew-ekvPy {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.UserReviewsForm-displayInline-xpk5f {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.UserReviewsForm-btnUPdate-MQUjK {
	display: inline-block;
}

.UserReviewsForm-btnModalDelete-JJcmJ {
	display: inline-block;
	margin-left: 15px;
}

.UserReviewsForm-radioBtn-eseeo {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.UserReviewsForm-backgroundImg-qu5cE {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.UserReviewsForm-btnUPdate-MQUjK {
		display: block;
		margin-bottom: 12px;
	}

	.UserReviewsForm-btnModalDelete-JJcmJ {
		display: block;
		margin-left: 0px;
	}

	.UserReviewsForm-btnWidth-H35ho {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.UserReviewsForm-bannerImageBg-YJM9H {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.UserReviewsForm-bannerDelete-PSdDW {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.UserReviewsForm-modalRoot-MtG_5 {
	padding: 32px;
}

.UserReviewsForm-modalBorderBottom-ju2Qg {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.UserReviewsForm-logInModalBody-qjXYU {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.UserReviewsForm-exportSection-UxiLb {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.UserReviewsForm-exportSectionGridSub-llbBi {
	grid-template-columns: 50% 49% !important;
}

.UserReviewsForm-exportText-Iogag {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.UserReviewsForm-exportLinkImg-MTcrB {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.UserReviewsForm-vtrMiddle-yafEp {
	vertical-align: middle;
}

.UserReviewsForm-exportImg-_YDNH {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.UserReviewsForm-profileViewlabel-o4XnO {
	display: inline-block;
	width: 38%
}

.UserReviewsForm-profileViewMainContent-AFtZc {
	display: inline-block;
	width: 62%;
}

.UserReviewsForm-profileViewMain-LngwQ {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.UserReviewsForm-profileViewInner-NQB4p {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.UserReviewsForm-profileImageSection-Xcunf {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.UserReviewsForm-lastviewInner-VVYvB {
	padding: 10px;
}

.UserReviewsForm-whyHostHoriLine-JqzwO {
	margin: 30px 0;
}

.UserReviewsForm-tableGrid-V2ZZe {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.UserReviewsForm-headingContent-hAPFC {
	font-size: 18px;
	font-weight: 500;
}

.UserReviewsForm-refundTextColor-f94ME {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.UserReviewsForm-dividerLine-Tns33 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.UserReviewsForm-smallContent-HArGE {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.UserReviewsForm-sideAdminPageWrapper-uvwnq {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.UserReviewsForm-sideAdminPageWrapper-uvwnq {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.UserReviewsForm-exportSection-UxiLb {
		grid-template-columns: 100%;
	}

	.UserReviewsForm-exportSectionGridSub-llbBi {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.UserReviewsForm-profileViewlabel-o4XnO {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.UserReviewsForm-profileViewMainContent-AFtZc {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.UserReviewsForm-ChangeToUpperCase-xC2Nx {
	text-transform: uppercase
}

.UserReviewsForm-noBorder-kQmYA {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.UserReviewsForm-siteAdminHeading-tmsA7 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.UserReviewsForm-siteAdminSubHeading-MaWNR {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.UserReviewsForm-adminFormDivider-QD_ye {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.UserReviewsForm-errorMessage-QYVxj {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.UserReviewsForm-panelHeader-HsCu2 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.UserReviewsForm-formGroup-cjcjP {
  margin-bottom: 6px;
}

.UserReviewsForm-select-_JLbs {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.UserReviewsForm-labelText-ydHzf {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.UserReviewsForm-space1-rNpLw {
	margin-bottom: 6px !important;
}

.UserReviewsForm-space2-Ml1NJ {
	margin-bottom: 12px !important;
}

.UserReviewsForm-space3-NeMQH {
	margin-bottom: 18px !important;
}

.UserReviewsForm-space4-oB4Cu {
	margin-bottom: 24px !important;
}

.UserReviewsForm-space5-OxBs5 {
	margin-bottom: 30px !important;
}

.UserReviewsForm-space6-ukCQm {
	margin-bottom: 36px !important;
}

.UserReviewsForm-space7-FThmC {
	margin-bottom: 42px !important;
}

.UserReviewsForm-spaceTop8-Kdwba {
	margin-bottom: 48px !important;
}

.UserReviewsForm-spaceTop1-t3INf {
	margin-top: 6px !important;
}

.UserReviewsForm-spaceTop2-S6sKe {
	margin-top: 12px !important;
}

.UserReviewsForm-spaceTop3-tW87Y {
	margin-top: 18px !important;
}

.UserReviewsForm-spaceTop4-TvGZt {
	margin-top: 24px !important;
}

.UserReviewsForm-spaceTop5-IBvuf {
	margin-top: 30px !important;
}

.UserReviewsForm-spaceTop6-n7Zah {
	margin-top: 36px !important;
}

.UserReviewsForm-spaceTop7-NnVNy {
	margin-top: 42px !important;
}

.UserReviewsForm-spaceTop8-Kdwba {
	margin-top: 48px !important;
}

.UserReviewsForm-noMargin-HM8fD {
	margin: 0px !important;
}

.UserReviewsForm-padding1-GyA4C {
	padding-bottom: 6px !important;
}

.UserReviewsForm-padding2-UUQCc {
	padding-bottom: 12px !important;
}

.UserReviewsForm-padding3-tVviU {
	padding-bottom: 18px !important;
}

.UserReviewsForm-padding4-IgcdJ {
	padding-bottom: 24px !important;
}

.UserReviewsForm-padding5-ORgfN {
	padding-bottom: 30px !important;
}

.UserReviewsForm-padding6-rWZT4 {
	padding-bottom: 36px !important;
}

.UserReviewsForm-padding7-XXXbX {
	padding-bottom: 42px !important;
}

.UserReviewsForm-paddingTop1-VilTj {
	padding-top: 6px !important;
}

.UserReviewsForm-paddingTop2-ySkXT {
	padding-top: 12px !important;
}

.UserReviewsForm-paddingTop3-erG36 {
	padding-top: 18px !important;
}

.UserReviewsForm-paddingTop4-eLiR8 {
	padding-top: 24px !important;
}

.UserReviewsForm-paddingTop5-HqMfy {
	padding-top: 30px !important;
}

.UserReviewsForm-paddingTop6-JDP8a {
	padding-top: 36px !important;
}

.UserReviewsForm-paddingTop7-ZbZ6Y {
	padding-top: 42px !important;
}

.UserReviewsForm-noPadding-Hd_Ky {
	padding: 0px !important;
}

.UserReviewsForm-textBold-vBDgU {
	font-weight: 500 !important;
}

.UserReviewsForm-textBolder-GkCYd {
	font-weight: 700 !important;
}

.UserReviewsForm-textNormal-q6Mq6 {
	font-weight: normal !important;
}

.UserReviewsForm-spaceBottom20-Wh9aO {
	margin-bottom: 20px;
}

.UserReviewsForm-spaceBottom10-uptlq {
	margin-bottom: 10px;
}

.UserReviewsForm-marginNone-EdCae {
	margin: 0;
}

.UserReviewsForm-spaceBottom15-NsvGD {
	margin-bottom: 15px;
}

.UserReviewsForm-marginTopNone-eOehQ {
	margin-top: 0;
}

.UserReviewsForm-spaceTop11-PR00z {
	margin-top: 11px;
}

.UserReviewsForm-spaceTop21-D2Aho {
	margin-top: 21px;
}

.UserReviewsForm-spaceTop20-Yw_pV {
	margin-top: 20px;
}

.UserReviewsForm-spaceTop10-fphLD {
	margin-top: 10px;
}

/*New Design Text Colors */

.UserReviewsForm-textDarkBlue-cdvui {
	color: rgb(20, 39, 94) !important;
}

.UserReviewsForm-textLightBlue-nR1Yk {
	color: rgb(57, 87, 106) !important;
}

.UserReviewsForm-textLightSandleGreen-jBg_e {
	color: rgb(76, 86, 41) !important;
}

.UserReviewsForm-textLightBrown-K1cJh {
	color: rgb(115, 79, 33) !important;
}

.UserReviewsForm-textMediumMaroon-fbD8W {
	color: rgb(87, 37, 51) !important;
}

.UserReviewsForm-textBrown-t80LE {
	color: rgb(160, 47, 24) !important;
}

.UserReviewsForm-textMaroon-Uvjwv {
	color: rgb(155, 49, 67) !important;
}

.UserReviewsForm-textDarkBrown-sYRPR {
	color: rgb(83, 18, 16) !important;
}

.UserReviewsForm-textMediumBrown-ov1SU {
	color: rgb(142, 28, 10) !important;
}

.UserReviewsForm-textSkyBlue-KrXCZ {
	color: rgb(37, 117, 141) !important;
}

.UserReviewsForm-textGray-FQHJi {
	color: rgb(77, 65, 51) !important;
}

.UserReviewsForm-adminReviewStar-qOR8m svg {
    font-size: 32px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/UserReviewsForm/UserReviewsForm.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,eAAe;IACf,eAAe;AACnB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.adminReviewStar svg {\n    font-size: 32px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `UserReviewsForm-commonHeaderAdmin-UsNnT`,
	"adminLayout": `UserReviewsForm-adminLayout-mvAB4`,
	"box": `UserReviewsForm-box-Iw0Q0`,
	"exportLink": `UserReviewsForm-exportLink-x45UE`,
	"blockCenter": `UserReviewsForm-blockCenter-JPbC6`,
	"panelHeader": `UserReviewsForm-panelHeader-HsCu2`,
	"currencyselect": `UserReviewsForm-currencyselect-Sqy6j`,
	"mar0": `UserReviewsForm-mar0-b8aea`,
	"sideAdminPageWrapper": `UserReviewsForm-sideAdminPageWrapper-uvwnq`,
	"table": `UserReviewsForm-table-d3XZK`,
	"tableRow": `UserReviewsForm-tableRow-FqJqX`,
	"tableCell": `UserReviewsForm-tableCell-wcxzn`,
	"formGroup": `UserReviewsForm-formGroup-cjcjP`,
	"select": `UserReviewsForm-select-_JLbs`,
	"noMargin": `UserReviewsForm-noMargin-HM8fD`,
	"labelTextNew": `UserReviewsForm-labelTextNew-ekvPy`,
	"displayInline": `UserReviewsForm-displayInline-xpk5f`,
	"btnUPdate": `UserReviewsForm-btnUPdate-MQUjK`,
	"btnModalDelete": `UserReviewsForm-btnModalDelete-JJcmJ`,
	"radioBtn": `UserReviewsForm-radioBtn-eseeo`,
	"backgroundImg": `UserReviewsForm-backgroundImg-qu5cE`,
	"btnWidth": `UserReviewsForm-btnWidth-H35ho`,
	"bannerImageBg": `UserReviewsForm-bannerImageBg-YJM9H`,
	"bannerDelete": `UserReviewsForm-bannerDelete-PSdDW`,
	"modalRoot": `UserReviewsForm-modalRoot-MtG_5`,
	"modalBorderBottom": `UserReviewsForm-modalBorderBottom-ju2Qg`,
	"logInModalBody": `UserReviewsForm-logInModalBody-qjXYU`,
	"exportSection": `UserReviewsForm-exportSection-UxiLb`,
	"exportSectionGridSub": `UserReviewsForm-exportSectionGridSub-llbBi`,
	"exportText": `UserReviewsForm-exportText-Iogag`,
	"exportLinkImg": `UserReviewsForm-exportLinkImg-MTcrB`,
	"vtrMiddle": `UserReviewsForm-vtrMiddle-yafEp`,
	"exportImg": `UserReviewsForm-exportImg-_YDNH`,
	"profileViewlabel": `UserReviewsForm-profileViewlabel-o4XnO`,
	"profileViewMainContent": `UserReviewsForm-profileViewMainContent-AFtZc`,
	"profileViewMain": `UserReviewsForm-profileViewMain-LngwQ`,
	"profileViewInner": `UserReviewsForm-profileViewInner-NQB4p`,
	"profileImageSection": `UserReviewsForm-profileImageSection-Xcunf`,
	"lastviewInner": `UserReviewsForm-lastviewInner-VVYvB`,
	"whyHostHoriLine": `UserReviewsForm-whyHostHoriLine-JqzwO`,
	"tableGrid": `UserReviewsForm-tableGrid-V2ZZe`,
	"headingContent": `UserReviewsForm-headingContent-hAPFC`,
	"refundTextColor": `UserReviewsForm-refundTextColor-f94ME`,
	"dividerLine": `UserReviewsForm-dividerLine-Tns33`,
	"smallContent": `UserReviewsForm-smallContent-HArGE`,
	"ChangeToUpperCase": `UserReviewsForm-ChangeToUpperCase-xC2Nx`,
	"noBorder": `UserReviewsForm-noBorder-kQmYA`,
	"siteAdminHeading": `UserReviewsForm-siteAdminHeading-tmsA7`,
	"siteAdminSubHeading": `UserReviewsForm-siteAdminSubHeading-MaWNR`,
	"adminFormDivider": `UserReviewsForm-adminFormDivider-QD_ye`,
	"errorMessage": `UserReviewsForm-errorMessage-QYVxj`,
	"labelText": `UserReviewsForm-labelText-ydHzf`,
	"space1": `UserReviewsForm-space1-rNpLw`,
	"space2": `UserReviewsForm-space2-Ml1NJ`,
	"space3": `UserReviewsForm-space3-NeMQH`,
	"space4": `UserReviewsForm-space4-oB4Cu`,
	"space5": `UserReviewsForm-space5-OxBs5`,
	"space6": `UserReviewsForm-space6-ukCQm`,
	"space7": `UserReviewsForm-space7-FThmC`,
	"spaceTop8": `UserReviewsForm-spaceTop8-Kdwba`,
	"spaceTop1": `UserReviewsForm-spaceTop1-t3INf`,
	"spaceTop2": `UserReviewsForm-spaceTop2-S6sKe`,
	"spaceTop3": `UserReviewsForm-spaceTop3-tW87Y`,
	"spaceTop4": `UserReviewsForm-spaceTop4-TvGZt`,
	"spaceTop5": `UserReviewsForm-spaceTop5-IBvuf`,
	"spaceTop6": `UserReviewsForm-spaceTop6-n7Zah`,
	"spaceTop7": `UserReviewsForm-spaceTop7-NnVNy`,
	"padding1": `UserReviewsForm-padding1-GyA4C`,
	"padding2": `UserReviewsForm-padding2-UUQCc`,
	"padding3": `UserReviewsForm-padding3-tVviU`,
	"padding4": `UserReviewsForm-padding4-IgcdJ`,
	"padding5": `UserReviewsForm-padding5-ORgfN`,
	"padding6": `UserReviewsForm-padding6-rWZT4`,
	"padding7": `UserReviewsForm-padding7-XXXbX`,
	"paddingTop1": `UserReviewsForm-paddingTop1-VilTj`,
	"paddingTop2": `UserReviewsForm-paddingTop2-ySkXT`,
	"paddingTop3": `UserReviewsForm-paddingTop3-erG36`,
	"paddingTop4": `UserReviewsForm-paddingTop4-eLiR8`,
	"paddingTop5": `UserReviewsForm-paddingTop5-HqMfy`,
	"paddingTop6": `UserReviewsForm-paddingTop6-JDP8a`,
	"paddingTop7": `UserReviewsForm-paddingTop7-ZbZ6Y`,
	"noPadding": `UserReviewsForm-noPadding-Hd_Ky`,
	"textBold": `UserReviewsForm-textBold-vBDgU`,
	"textBolder": `UserReviewsForm-textBolder-GkCYd`,
	"textNormal": `UserReviewsForm-textNormal-q6Mq6`,
	"spaceBottom20": `UserReviewsForm-spaceBottom20-Wh9aO`,
	"spaceBottom10": `UserReviewsForm-spaceBottom10-uptlq`,
	"marginNone": `UserReviewsForm-marginNone-EdCae`,
	"spaceBottom15": `UserReviewsForm-spaceBottom15-NsvGD`,
	"marginTopNone": `UserReviewsForm-marginTopNone-eOehQ`,
	"spaceTop11": `UserReviewsForm-spaceTop11-PR00z`,
	"spaceTop21": `UserReviewsForm-spaceTop21-D2Aho`,
	"spaceTop20": `UserReviewsForm-spaceTop20-Yw_pV`,
	"spaceTop10": `UserReviewsForm-spaceTop10-fphLD`,
	"textDarkBlue": `UserReviewsForm-textDarkBlue-cdvui`,
	"textLightBlue": `UserReviewsForm-textLightBlue-nR1Yk`,
	"textLightSandleGreen": `UserReviewsForm-textLightSandleGreen-jBg_e`,
	"textLightBrown": `UserReviewsForm-textLightBrown-K1cJh`,
	"textMediumMaroon": `UserReviewsForm-textMediumMaroon-fbD8W`,
	"textBrown": `UserReviewsForm-textBrown-t80LE`,
	"textMaroon": `UserReviewsForm-textMaroon-Uvjwv`,
	"textDarkBrown": `UserReviewsForm-textDarkBrown-sYRPR`,
	"textMediumBrown": `UserReviewsForm-textMediumBrown-ov1SU`,
	"textSkyBlue": `UserReviewsForm-textSkyBlue-KrXCZ`,
	"textGray": `UserReviewsForm-textGray-FQHJi`,
	"adminReviewStar": `UserReviewsForm-adminReviewStar-qOR8m`
};
module.exports = ___CSS_LOADER_EXPORT___;
